export function gtagEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;          // SSR safety
  if (!window.gtag) {
    // fallback por si gtag no está definido pero dataLayer sí
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
    return;
  }
  window.gtag("event", eventName, params);
}

export function googleAdsConversion(sendTo, extraParams = {}) {
  gtagEvent("conversion", { send_to: sendTo, ...extraParams });
}
